import register from '../register';

register( 'ces-network-carousel', function() {

  let captions = document.querySelectorAll('.ces-carousel__caption');
  let dots     = document.querySelectorAll('.ces-carousel__dot');
  let images   = document.querySelectorAll('.ces-carousel__image');

  let currentIndex = 0;

  let timer;

  // initialize dots with numerical indexes + add click handlers
  dots.forEach( function( el, index ) {
    el.dataset.index = index;
    el.addEventListener( 'click', changeCaption );
  });

  function changeCaption( e ) {
    clearTimer();

    let clickIndex = +e.currentTarget.dataset.index;
    if ( clickIndex === currentIndex ) {
      return;
    }
    let oldIndex = currentIndex;
    currentIndex = clickIndex;
    fadeOutIn( oldIndex, clickIndex );

    setTimer();
  }

  function fadeOutIn( outIndex, inIndex ) {
    [ dots, captions, images ].forEach( function( item ) {
      item[ outIndex ].classList.remove('active');
      item[ inIndex ].classList.add('active');
    });
  }

  function increment() {
    let oldIndex = currentIndex;
    currentIndex = ++currentIndex;

    if ( currentIndex >= captions.length ) {
      currentIndex = 0;
    }

    fadeOutIn( oldIndex, currentIndex );
  }

  function setTimer() {
    timer = setInterval( increment, 5000 );
  }

  function clearTimer() {
    clearInterval( timer );
  }

  setTimer();

});

export default undefined;
